import { render, staticRenderFns } from "./PlatformCreate.vue?vue&type=template&id=20749862&scoped=true&"
import script from "./PlatformCreate.vue?vue&type=script&lang=js&"
export * from "./PlatformCreate.vue?vue&type=script&lang=js&"
import style0 from "./PlatformCreate.vue?vue&type=style&index=0&id=20749862&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20749862",
  null
  
)

export default component.exports